package com.kaihuoy.web

import com.kaihuoy.shared.data.User
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.functions.functions
import kotlinx.serialization.Serializable
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import kotlinx.coroutines.flow.collect
import kotlin.js.Date

@Serializable
data class DeleteUserRequest(val uid: String)

class WebFirebaseRepository {
    private val scope = MainScope()

    fun createUserAndSendInvitation(email: String, displayName: String, isAdmin: Boolean, onComplete: (Boolean, String?) -> Unit) {
        scope.launch {
            try {
                // 1. Luodaan väliaikainen Firebase-app, jotta ylläpitäjä ei kirjaudu ulos
                val appName = "Invitation_${Date.now().toLong()}"
                val secondaryApp = Firebase.initialize(options = FirebaseService.options, name = appName)
                val secondaryAuth = Firebase.auth(secondaryApp)

                // 2. Luodaan käyttäjä väliaikaisella salasanalla
                val dummyPassword = "Temp${Date.now().toLong()}!"
                val credential = secondaryAuth.createUserWithEmailAndPassword(email, dummyPassword)
                val uid = credential.user?.uid ?: throw Exception("UID puuttuu")

                // 3. Lähetetään salasanan palautusviesti (toimii kutsuna)
                secondaryAuth.sendPasswordResetEmail(email)

                // 4. Tallennetaan käyttäjätiedot tietokantaan
                val newUser = User(uid = uid, email = email, displayName = displayName, isAdmin = isAdmin)
                FirebaseService.database.reference("users").child(uid).setValue(newUser)

                onComplete(true, null)
            } catch (e: Exception) {
                console.error("Kutsun lähetys epäonnistui", e)
                onComplete(false, e.message)
            }
        }
    }

    fun saveUser(user: User, onComplete: (Boolean) -> Unit) {
        scope.launch {
            try {
                FirebaseService.database.reference("users").child(user.uid).setValue(user)
                onComplete(true)
            } catch (e: Exception) {
                console.error("saveUser failed", e)
                onComplete(false)
            }
        }
    }

    fun sendPasswordResetEmail(email: String, onComplete: (Boolean, String?) -> Unit) {
        scope.launch {
            try {
                FirebaseService.auth.sendPasswordResetEmail(email)
                onComplete(true, null)
            } catch (e: Exception) {
                console.error("sendPasswordResetEmail failed", e)
                onComplete(false, e.message)
            }
        }
    }


    fun deleteUser(uid: String, onComplete: (Boolean) -> Unit) {
        scope.launch {
            try {
                // 1. Poistetaan Auth-palvelusta Cloud Functionin kautta
                val deleteFunc = FirebaseService.functions.httpsCallable("deleteAuthUser")
                deleteFunc.invoke(DeleteUserRequest(uid))

                // 2. Poistetaan tietokannasta
                FirebaseService.database.reference("users").child(uid).removeValue()

                onComplete(true)
            } catch (e: Exception) {
                console.error("deleteUser failed", e)
                onComplete(false)
            }
        }
    }

    fun updateUserAdminStatus(uid: String, isAdmin: Boolean, onComplete: (Boolean) -> Unit) {
        scope.launch {
            try {
                FirebaseService.database.reference("users").child(uid).child("isAdmin").setValue(isAdmin)
                onComplete(true)
            } catch (e: Exception) {
                console.error("updateUserAdminStatus failed", e)
                onComplete(false)
            }
        }
    }

    fun updateUserHuoltoStatus(uid: String, isHuolto: Boolean, onComplete: (Boolean) -> Unit) {
        scope.launch {
            try {
                FirebaseService.database.reference("users").child(uid).child("isHuolto").setValue(isHuolto)
                onComplete(true)
            } catch (e: Exception) {
                console.error("updateUserHuoltoStatus failed", e)
                onComplete(false)
            }
        }
    }

    fun updateUserPutkityoStatus(uid: String, isPutkityo: Boolean, onComplete: (Boolean) -> Unit) {
        scope.launch {
            try {
                FirebaseService.database.reference("users").child(uid).child("isPutkityo").setValue(isPutkityo)
                onComplete(true)
            } catch (e: Exception) {
                console.error("updateUserPutkityoStatus failed", e)
                onComplete(false)
            }
        }
    }
}